<div #scrollTarget></div>
<div class="search-form">
    <div class="input-group">
        <span class="input-group-addon" id="basic-addon1">
            <span class="sp-icon icon-ap-search"></span>
        </span>
        <input
            #searchInput
            type="text"
            class="form-control"
            [attr.placeholder]="'search_placeholder' | translate"
            aria-describedby="basic-addon1"
            (keyup.enter)="query.setValue(searchInput.value)"
        />
    </div>
    <button type="button" class="btn btn-success" (click)="query.setValue(searchInput.value)">
        {{ "search" | translate }}
    </button>
</div>

<div
    class="search-results narrow-gutter row"
    infiniteScroll
    [infiniteScrollDistance]="scrollDistance"
    [infiniteScrollContainer]="'.modal-body'"
    [fromRoot]="true"
    (scrolled)="onScroll($event)"
>
    <div class="col-xs-12 col-sm-6 col-md-4" *ngFor="let image of images$ | async">
        <sp-single-image [image]="image" [size]="'small'" (imageClick)="selectImage($event)"></sp-single-image>
    </div>
</div>
